<header #headerEl
  [ngClass]="{'navbar-fixed-top': isHeaderFixed(), 'navbar-relative-top': !isHeaderFixed()}"
  class="navbar navbar-inverse text-center">
  @defer (when loadHeader()) {
    <app-header></app-header>
  } @placeholder {
    <div class="header-placeholder"></div>
  }
</header>

@defer (when isOffline()) {
  <app-offline-banner></app-offline-banner>
} @placeholder {
  <div></div>
}

<!-- WebDDN Cart Flyout — sibling of <main> so body push shifts full layout -->
<app-webddncart></app-webddncart>

<main [ngClass]="app_type !== 'web' && header.authentication.user == false && isHeaderFixed() ? 'general-header' : ''" class="content">
  <router-outlet>
    <title>{title}</title>
  </router-outlet>
</main>

@defer (on viewport) {
  <footer>
    <app-footer></app-footer>
  </footer>
} @placeholder {
  <footer style="min-height: 100px;"></footer>
}